import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import baseUrl from './constants'
import ElementUI from 'element-ui'
import directive from './directive' // directive
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import vuePicturePreview from 'vue-picture-preview'

Vue.prototype.BaseUrl = baseUrl

Vue.use(vuePicturePreview)
Vue.use(directive)

// Vue.use(ElementUI)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
